import * as React from "react";
import styled, { css } from "styled-components";
import { Collapse } from "@mantine/core";
import Spinner from "components/common/Spinner";
import { Row, Col, Button } from "components/bootstrap";
import Icon from "components/common/Icon";
import useDisclosure from "util/hooks/useDisclosure";
const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: ${theme.spacings.xs};

    *:not(:first-child) {
      margin-left: 10px;
    }
  `
);
export const Headline = styled.h2`
  margin-bottom: 5px;
  display: inline;
`;
const LoadingSpinner = styled(Spinner)(
  ({ theme }) => css`
    margin-left: 10px;
    font-size: ${theme.fonts.size.h3};
  `
);
const FlexWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    gap: ${theme.spacings.sm};
    align-items: center;
  `
);
export const SectionCol = styled(Col)``;
const SectionComponent = ({
  children,
  title,
  titleAs = void 0,
  showLoading = false,
  headerActions = void 0,
  className = "",
  collapsible = false,
  defaultClosed = false,
  disableCollapseButton = false
}) => {
  const [opened, { toggle }] = useDisclosure(!defaultClosed);
  return /* @__PURE__ */ React.createElement(Row, { className: `content ${className}` }, /* @__PURE__ */ React.createElement(SectionCol, { xs: 12 }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(Headline, { as: titleAs }, title, showLoading && /* @__PURE__ */ React.createElement(LoadingSpinner, { text: "", delay: 0 })), /* @__PURE__ */ React.createElement(FlexWrapper, null, headerActions, collapsible && /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "sm",
      bsStyle: opened ? "primary" : "default",
      onClick: toggle,
      "data-testid": "collapseButton",
      disabled: disableCollapseButton
    },
    /* @__PURE__ */ React.createElement(Icon, { size: "xs", name: opened ? "keyboard_arrow_up" : "keyboard_arrow_down" })
  ))), !collapsible && children, collapsible && /* @__PURE__ */ React.createElement(Collapse, { in: opened }, children)));
};
export default SectionComponent;
